import React, { memo, useCallback } from 'react';
import styled from 'styled-components';
import { HourlyForecastChartTypes } from '../../common/types';
import { translate } from '../../../../common/translation/translate';
import { reduxConnect } from '../../../../common';
import { selectHourlyForecastChart } from '../../../../common/actions/hourlyForecastPageViewActions';

interface GraphNavItemProps {
    graphNavItemName: keyof typeof HourlyForecastChartTypes;
    selectedHourlyForecastChart?: keyof typeof HourlyForecastChartTypes;
    selectHourlyForecastChart(selectedGraph: keyof typeof HourlyForecastChartTypes): void; 
}

const mapStoreStateToProps = (storeState: any) => {
    const { hourlyForecastPage } =  storeState || {};
    const { selectedHourlyForecastChart } = hourlyForecastPage || {};

    return {
        selectedHourlyForecastChart
    };
};

const mapDispatchToProps = {
    selectHourlyForecastChart
};

export const ChartNavItem = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(memo(({
    graphNavItemName, 
    selectedHourlyForecastChart = HourlyForecastChartTypes.precip, 
    selectHourlyForecastChart }: GraphNavItemProps ) => {

    const handleChartNavItemClick = useCallback(() => {
        if (graphNavItemName && selectedHourlyForecastChart !== graphNavItemName) {
            selectHourlyForecastChart(graphNavItemName);
        }
    }, [graphNavItemName, selectedHourlyForecastChart]);

    return (
        <Container isSelectedGraph={graphNavItemName === selectedHourlyForecastChart} onClick={handleChartNavItemClick}>
            {translate(graphNavItemName)}
        </Container>
    );
}));

interface ContainerProps {
    isSelectedGraph: boolean;
}

const Container = styled.div<ContainerProps>`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 50%;
    padding: 3px 8px;
    border-bottom: 2px solid rgba(255,255,255,0.4);
    font-size: 15px;
    font-weight: 400;
    color: white;
    cursor: pointer;
    transition: border-color .15s ease-in-out;
    ${({ isSelectedGraph }) => isSelectedGraph && `
        font-weight: 600;
        border-bottom-color: #ffffff;
    `}
`;